import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "course_group_courses_count": {
      "column": {
        "default": "0",
        "name": "course_group_courses_count",
        "null": false,
        "type": "integer"
      },
      "name": "course_group_courses_count",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "icon": {
      "column": {
        "default": null,
        "name": "icon",
        "null": true,
        "type": "string"
      },
      "name": "icon",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "CourseGroup",
  "collectionKey": "course_groups",
  "collectionName": "course_groups",
  "i18nKey": "course_group",
  "camelizedLower": "courseGroup",
  "name": "CourseGroup",
  "nameDasherized": "course-group",
  "pluralName": "course_groups",
  "ransackable_associations": [
    {
      "className": "CourseGroup::Audit",
      "collectionName": "course_group_audits",
      "foreignKey": "course_group_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "CourseGroupAudit",
      "through": null
    },
    {
      "className": "CourseGroupCourse",
      "collectionName": "course_group_courses",
      "foreignKey": "course_group_id",
      "name": "course_group_courses",
      "macro": "has_many",
      "resource_name": "CourseGroupCourse",
      "through": null
    },
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "courses",
      "macro": "has_many",
      "resource_name": "Course",
      "through": "course_group_courses"
    },
    {
      "className": "CourseGroup::Audit",
      "collectionName": "course_group_audits",
      "foreignKey": "course_group_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "CourseGroupAudit",
      "through": null
    },
    {
      "className": "CourseGroup::Translation",
      "collectionName": null,
      "foreignKey": "course_group_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "CourseGroup::Translation",
      "collectionName": null,
      "foreignKey": "course_group_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "course_group_courses_count",
      "column": {
        "default": "0",
        "name": "course_group_courses_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "icon",
      "column": {
        "default": null,
        "name": "icon",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "courses",
      "macro": "has_many",
      "resource_name": "Course",
      "through": "course_group_courses"
    },
    {
      "className": "CourseGroupCourse",
      "collectionName": "course_group_courses",
      "foreignKey": "course_group_id",
      "name": "course_group_courses",
      "macro": "has_many",
      "resource_name": "CourseGroupCourse",
      "through": null
    }
  ],
  "paramKey": "course_group",
  "primaryKey": "id"
}

/** Frontend model for CourseGroup. */
class CourseGroup extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number} */
  courseGroupCoursesCount() {
    return this.readAttributeUnderscore("course_group_courses_count")
  }

  /** @returns {boolean} */
  hasCourseGroupCoursesCount() {
    const value = this.courseGroupCoursesCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  icon() {
    return this.readAttributeUnderscore("icon")
  }

  /** @returns {boolean} */
  hasIcon() {
    const value = this.icon()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course.js").default>} */
  courses() {
    const modelClass = modelClassRequire("Course")

    return new Collection(
      {
        reflectionName: "courses",
        model: this,
        modelName: "Course",
        modelClass
      },
      {
        params: {
          through: {
            model: "CourseGroup",
            id: this.primaryKey(),
            reflection: "courses"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./course.js").default>>} */
  loadCourses() {
    const modelClass = modelClassRequire("Course")

    return this._loadHasManyReflection(
      {
        reflectionName: "courses",
        model: this,
        modelClass
      },
      {
        params: {
          through: {
            model: "CourseGroup",
            id: this.primaryKey(),
            reflection: "courses"
          }
        }
      }
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-group-course.js").default>} */
  courseGroupCourses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseGroupCourse")

    const ransack = {}

    ransack["course_group_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "course_group_courses",
        model: this,
        modelName: "CourseGroupCourse",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-group-course.js").default>>} */
  loadCourseGroupCourses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseGroupCourse")

    const ransack = {}

    ransack["course_group_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "course_group_courses",
        model: this,
        modelClass
      },
      {ransack}
    )
  }
}

export default CourseGroup
